import { compose } from 'recompose';
import PropTypes from 'prop-types';
import React from 'react';
import { GatewayDest } from 'react-gateway';
import { BACK_BUTTON_GATEWAY } from '../constants';
import WithShopName from '../../hoc/WithShopName';
import Title from '../../components/Title';
import WithKioskHomeUrl from '../../hoc/WithKioskHomeUrl';
import Layout from '../../components/Layout';
import Passcode from '../../passcode';

const MainLayout = ({ children, homeUrl, shopName }) => (
  <Layout shopLayout homeUrl={homeUrl} kiosk>
    <Title>{ shopName }</Title>
    <GatewayDest name={BACK_BUTTON_GATEWAY} />
    <div className="u-pt">
      <GatewayDest name="subtitle" className="u-show-for-large-and-up" />
      { children }
    </div>
    <Passcode />
  </Layout>
);
MainLayout.propTypes = {
  children: PropTypes.node.isRequired,
  homeUrl: PropTypes.string.isRequired,
  shopName: PropTypes.string,
};
MainLayout.defaultProps = {
  shopName: '',
};

export default compose(
  WithKioskHomeUrl,
  WithShopName,
)(MainLayout);



// WEBPACK FOOTER //
// ./src/app/kiosk/components/Kiosk.jsx